export { GtmComponent } from './gtm-component';
